export default __webpack_public_path__ + "static/media/3008.d75964ea.png";